import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import SecLogo from '../../../../utility/unnamed.png';
import SecBuilding from '../../../../assets/files/img/aaa.jpg';

const Disclaimer = () => {
  return (
    <div className="relative min-h-screen overflow-x-hidden">
      {/* ── Background Image ── */}
      <img
        src={SecBuilding}
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />

      {/* ── Dark Gradient Overlay ── */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(100deg, rgba(0,36,22,0.93) 0%, rgba(0,50,32,0.82) 45%, rgba(0,30,18,0.65) 100%)',
        }}
      />

      {/* ── Main Canvas Layer ── */}
      <div
        style={{
          position: 'relative',
          zIndex: 10,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {/* Centered Content Wrapper */}
        <div className="flex-1 flex flex-col items-center justify-center p-4 sm:p-8 md:p-12">
          
          {/* Centered Document Card */}
          <div
            className="w-full max-w-3xl bg-white rounded-[20px] p-6 sm:p-10 my-auto"
            style={{ boxShadow: '0 24px 80px rgba(0,0,0,0.35)' }}
          >
            {/* Header / Branding Inside Card */}
            <header className="flex flex-col items-center text-center mb-6 pb-6 border-b border-gray-100">
              <img
                src={SecLogo}
                alt="SEC Logo"
                style={{ height: 60, width: 'auto', marginBottom: 12 }}
              />
              <h1 className="text-xl md:text-2xl font-extrabold text-[#111827] mb-1">
                Electronic Filing and Submission Tool (eFAST)
              </h1>
              <p className="text-xs sm:text-sm text-gray-500 mb-2">
                Facility Disclaimer Notice
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: '0.08em',
                    padding: '2px 10px',
                    borderRadius: 999,
                    background: 'rgba(15,130,105,0.1)',
                    color: '#0f8269',
                    border: '1px solid rgba(15,130,105,0.2)',
                  }}
                >
                  DISCLAIMER
                </span>
              </div>
            </header>

            {/* Document Content Body */}
            <div
              className="text-gray-700 text-sm leading-relaxed max-h-[60vh] overflow-y-auto pr-2"
              style={{ textAlign: 'justify' }}
            >
              <p className="font-bold text-center text-base text-gray-900 mb-6">
                Disclaimer of Warranties and Liability
              </p>

              <p className="font-semibold text-[#0f8269] mb-4 text-sm sm:text-base">
                The Contents of this Web Site are provided on an "as is" basis without warranties of any kind. To the fullest extent permitted by law, SEC eFAST does not warrant and hereby disclaims any warranty:
              </p>

              <div className="space-y-4 pl-2 border-l-2 border-[#0f8269]/30">
                <p className="pl-3 m-0">
                  As to the accuracy, correctness, reliability, currentness, timeliness, non-infringement, title, merchantability or fitness for any particular purpose of the Contents of this Portal; that the Contents available through this Web Site or any functions associated therewith will be uninterrupted or error-free, or that defects will be corrected.
                </p>

                <p className="pl-3 m-0">
                  SEC eFAST shall also not be liable for any damage or loss of any kind, howsoever caused as a result (direct or indirect) of the use of the Web Site, including but not limited to any damage or loss suffered as a result of reliance on the Contents contained in or available from the Web Site.
                </p>

                <p className="pl-3 m-0">
                  The Contents on this Web Site do not constitute financial or other professional advice. If financial or other professional advice is required, services of a competent professional should be sought.
                </p>
              </div>

              <hr className="my-8 border-gray-200" />

              <p className="font-bold text-center text-gray-400 text-xs tracking-widest">
                — END OF STATEMENT —
              </p>
            </div>

            {/* Card Footer Actions */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justify: 'space-between',
                width: '100%',
                marginTop: 20,
                paddingTop: 20,
                borderTop: '1px solid #f3f4f6',
              }}
            >
              <Link
                to="/user/login"
                style={{
                  color: '#0f8269',
                  fontWeight: 600,
                  fontSize: 14,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                }}
              >
                <ArrowLeftOutlined /> Back to Sign In
              </Link>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Disclaimer;